import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy px-4 py-12 text-center text-white/70" data-id="element-89" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-3xl" data-id="element-90" data-mp="3ggaovpzpm32t">
        <p className="font-serif text-2xl text-white" data-id="element-91" data-mp="3gh3qydnq44em">Sistema delle Costellazioni Familiari™</p>
        <p className="mt-3 text-sm font-semibold text-white/85" data-id="element-92" data-mp="32lrnnhvi55m3">
          Il sistema di guarigione per Costellazioni Familiari più completo in italiano.
        </p>
        <p className="mt-3 text-sm leading-relaxed" data-id="element-93" data-mp="3ugbrpazjbkkx">
          Perché la guarigione generazionale merita un vero sistema professionale.
        </p>
        <p className="mt-6 text-sm" data-id="element-94" data-mp="3lec94e8vg8fv">
          📧{' '}
          <a className="transition-colors duration-200 hover:text-amber" href="mailto:support@eurekalabs.com" data-id="element-95" data-mp="3ldu4at858lwc">
            support@eurekalabs.com
          </a>{' '}
          <span className="mx-2 text-white/40" data-id="element-96" data-mp="29ynjtg85axbw">·</span> 🌐 www.eurekalabs.store
        </p>
        <p className="mt-6 text-xs" data-id="element-97" data-mp="2ey05vyr700df">© Sistema delle Costellazioni Familiari™ 2026 — Tutti i diritti riservati.</p>
        <p className="mt-4 text-xs leading-relaxed text-white/55" data-id="element-98" data-mp="3l8qwa43iojrg">
          Questo prodotto è un download digitale. I risultati possono variare. Questo sistema non sostituisce il
          consiglio medico o psicologico professionale.
        </p>
      </div>
    </footer>;
}